<template>
  <el-table
    :data="measures"
    max-height="250"
    style="width: 100%"
    v-loading="loading"
    :default-sort="{prop: 'name', order: 'ascending'}"
  >
    <el-table-column
      prop="name"
      label="Név"
    />
    <el-table-column
      fixed="right"
      label=""
      width="120"
    >
      <template slot-scope="scope">
        <Actions :measure="scope.row" />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import Actions from './Actions'

  export default {

    components: {
      Actions
    },

    computed: {
      measures() {
        return this.$store.getters['declutterMeasure/measures'];
      },

      loading() {
        return this.$store.getters['declutterMeasure/loading'];
      }
    },

    async mounted() {
      await this.$store.dispatch('declutterMeasure/fetchAll');
    },
  }
</script>
